// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../closestTo/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var closestTo = convertToFP(fn, 2);
export default closestTo;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/closestTo/index.js
// module id = 823
// module chunks = 0